import { styled } from '@mui/material';

export const Styles = {
  ImageUploadSection: styled('div')({
    marginBottom: '20px'
  }),

  Label: styled('label')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '27px',
    color: '#212529',
    textTransform: 'uppercase',
    '&.required::after': {
      content: '"*"',
      color: '#FF0000',
      margin: '5px'
    }
  }),

  ImageInputContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '15px'
  }),

  UploadButton: styled('div')({
    backgroundColor: '#DFDFDF',
    color: 'white',
    width: '130px',
    height: '32px',
    position: 'relative',
    borderRadius: '5px',
    cursor: 'pointer'
  }),

  UploadLabel: styled('label')({
    fontSize: '16px',
    color: '#000000',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '35px',
    borderRadius: '5px',
    border: '1px black solid'
  }),

  ImageGalleryGrid: styled('div')`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
    margin-top: 12px;
  `,

  ImageCard: styled('div')`
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fafafa;
    user-select: none;
    cursor: grab;
    touch-action: none;
    width: 120px;
    height: 120px;

    &:active {
      cursor: grabbing;
    }

    &:hover {
      border-color: #04682e;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  `,

  ImagePreview: styled('img')`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,

  IndexCaption: styled('div')<{ $isCover: boolean }>`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: bold;
    border-top-right-radius: 4px;
    background-color: ${({ $isCover }) => ($isCover ? '#007bff' : '#ffffff')};
    color: ${({ $isCover }) => ($isCover ? '#ffffff' : '#333333')};
  `,

  DeleteButton: styled('button')({
    position: 'absolute',
    top: '4px',
    right: '4px',
    background: '#ff4444',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    opacity: 0.8,
    padding: 0,
    fontSize: '14px',
    lineHeight: '20px',
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 1
    }
  })
};
